import { filter, first, pipe } from 'rxjs';

import { select } from '@ngrx/store';

import { administratorFeature } from './administrator.feature';

export const selectValidAdministrator = pipe(
  select(administratorFeature.selectAdministrator),
  filter((administrator) => !!administrator),
);

export const selectFirstValidAdministrator = pipe(selectValidAdministrator, first());
